import React from 'react';
import groupBy from 'lodash/groupBy';
import {useUnsubscribe} from '../../util/hooks/useUnsubscribe';
import {useAuth} from '../../util/auth';
import {formatDate} from '../../util/format';
import {zonedTimeToUtc} from 'date-fns-tz';
import {cn} from '@/lib/utils';
import {Card} from '@/components/ui/card';
import {Typography} from '@/components/ui/typography';
import {Button} from '@/components/ui/button';

const PricingCard = (props) => {
    const featuresByLevel = Object.values(groupBy(props.features, 'level'));

    return (
        <Card className={cn('bg-card flex flex-col items-center shadow-lg p-4', {
            'bg-teal-500': props.featured,
            'text-white': props.featured
        })}>
            <Typography variant="h3">{props.title}</Typography>
            <Typography>{props.description}</Typography>

            <div>
                <img src={props.imgSrc} alt=""/>
                <div className={cn("flex justify-center items-baseline my-4", {
                    'text-white': props.featured
                })}>
                    <span className="mr-2 text-2xl font-extrabold">{props.price}{props.currency}</span>
                    <span className="">/month</span>
                </div>
            </div>
            <div className="my-4">
                {featuresByLevel.map((featuresLevel, idx) => {
                    return <ul key={idx} className="list-disc list-inside marker:text-teal-300">
                        {featuresLevel.map(f => {
                            return <li key={f.id}>
                                <span dangerouslySetInnerHTML={{
                                   __html: f.label
                                }} />
                            </li>
                        })}
                    </ul>
                })}
            </div>
            <PricingActiveSubscriptionActions
                id={props.id}
                featured={props.featured}
                title={props.title}
                onSelect={props.onSelect}
            />
        </Card>
    )
};

const PricingActiveSubscriptionActions = ({id, featured, title, onSelect}) => {
    const auth = useAuth();
    const user = auth?.user;
    const subscription = user?.subscription;
    const futureSubscription = user?.futureSubscription;
    const hasActiveSubscription = !!subscription?.id;
    const isTrialSubscriptionActive = !!subscription?.is_trial;
    const tz = user?.timezone;
    const handleUnsubscribe = useUnsubscribe();

    const isActiveSubscription = subscription?.product_id === id && !subscription?.is_trial;
    const isFutureSubscription = futureSubscription?.product_id === id;

    const statusText = isFutureSubscription ? 'next plan' : 'subscribed';
    const currentSubscription = isFutureSubscription ? futureSubscription : subscription;
    const subscriptionEndDate = currentSubscription?.is_trial ? currentSubscription?.end_time : currentSubscription?.next_payment_time;

    return <div>
        {isActiveSubscription || isFutureSubscription ? (
                <>
                    <Typography>
                        {statusText}
                    </Typography>
                    <Typography>
                        {
                            isFutureSubscription ? `Active from ${formatDate({
                                ts: zonedTimeToUtc(futureSubscription?.start_time?.date, futureSubscription?.start_time?.timezone).getTime() / 1000,
                                tz: tz
                            })}` : hasActiveSubscription ? `Next payment ${formatDate({
                                ts: zonedTimeToUtc(subscriptionEndDate?.date, subscriptionEndDate?.timezone).getTime() / 1000,
                                tz: tz
                            })}`: null
                        }
                    </Typography>
                    <Button
                        size="sm"
                        variant="destructive"
                        onClick={handleUnsubscribe}>
                        Cancel plan
                    </Button>
                </>
        ) : null}
        {!isFutureSubscription && !isActiveSubscription ? (
            <Button variant={featured ? "default" : "outline"} onClick={onSelect}>
                {hasActiveSubscription && !isTrialSubscriptionActive ? 'Switch plan' : `Choose ${title}`}
            </Button>
        ) : null}
    </div>
}

export default PricingCard;
